import { render, staticRenderFns } from "./NodeTicketList.vue?vue&type=template&id=32ff979e&scoped=true"
import script from "./NodeTicketList.vue?vue&type=script&lang=js"
export * from "./NodeTicketList.vue?vue&type=script&lang=js"
import style0 from "./NodeTicketList.vue?vue&type=style&index=0&id=32ff979e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ff979e",
  null
  
)

export default component.exports